export default __webpack_public_path__ + "static/media/17t.fb1daba2.jpg";